import { render } from "./AddwaiterView.vue?vue&type=template&id=28dffef6"
import script from "./AddwaiterView.vue?vue&type=script&lang=js"
export * from "./AddwaiterView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__